import { render, staticRenderFns } from "./compensationGlobalComponente.vue?vue&type=template&id=a72b672a"
import script from "./compensationGlobalComponente.vue?vue&type=script&lang=js"
export * from "./compensationGlobalComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports